import React from "react";
import Loader from "./Loader";
import { Backdrop, CircularProgress } from "@mui/material";

interface ILoadingBackdrop {
  readonly zIndex?: number;
}

const LoadingBackdrop: React.FC<React.PropsWithChildren<ILoadingBackdrop>> = ({
  children,
  zIndex,
}) => (
  <Backdrop
    sx={{
      color: "#fff",
      zIndex: zIndex ?? ((theme: any) => theme.zIndex.drawer + 1),
    }}
    open={true}
  >
    {children}
  </Backdrop>
);

export const SpinnerLoading: React.FC<ILoadingBackdrop> = (props) => (
  <LoadingBackdrop {...props}>
    <CircularProgress color="inherit" />
  </LoadingBackdrop>
);

export const QbLoading: React.FC<ILoadingBackdrop> = (props) => (
  <LoadingBackdrop {...props}>
    <Loader />
  </LoadingBackdrop>
);

export const NoLoading: React.FC = () => <></>;

export const LoadingUtils = {
  spinner: (props?: ILoadingBackdrop) => <SpinnerLoading {...props} />,
  qbLoader: (props?: ILoadingBackdrop) => <QbLoading {...props} />,
  none: () => <NoLoading />,
};

interface ILoading {
  readonly type?: "spinner" | "qb-loader" | "none";
  readonly zIndex?: number;
  readonly open?: boolean;
}

export default function Loading({
  type = "qb-loader",
  zIndex,
  open = false,
}: ILoading) {
  if (open === false) {
    return <NoLoading />;
  }

  const loadingType = type || "qb-loader";

  switch (loadingType) {
    case "spinner":
      return <SpinnerLoading zIndex={zIndex} />;
    case "qb-loader":
      return <QbLoading zIndex={zIndex} />;
    case "none":
      return <NoLoading />;
    default:
      return <QbLoading zIndex={zIndex} />;
  }
}
